import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "change-report-visual row"
}
const _hoisted_2 = { class: "col-sm-12" }

import { ref, computed, onMounted } from "vue";
import cms from "../../services/cms/cms";
import {
  CmsDocumentTypes,
  CmsTeamEffectivenessReview,
} from "../../services/cms/cms-type-definitions";
import cmsContentMap from "../../services/cms/cms-content-map";
import { TeamEffectivenessReviewApiModel } from "../../api-models";
import CharacterScopeColours from "../../styles/style-variables";

import HorizontalBarChart, {
  CategoryCountData,
  CategoryCountDataItem,
} from "./horizontal-bar-chart.vue";
import { getTeamEffectivenessReport } from "./get-team-effectiveness-report-team-id";


export default /*#__PURE__*/_defineComponent({
  __name: 'change-bar-chart-report-visual',
  props: {
    reviewId: {}
  },
  setup(__props: any) {

const props = __props;

const teamEffectivenessReport = ref<TeamEffectivenessReviewApiModel | null>(null);

const teamEffectivenessQuestionnaire = ref<CmsTeamEffectivenessReview | null>(null);

const changeData = computed<CategoryCountData>(() => {
  if (!teamEffectivenessReport.value || !teamEffectivenessQuestionnaire.value) {
    return [];
  }

  const questionIdsToText = teamEffectivenessQuestionnaire.value.data.body.reduce(
    (obj, question) => {
      obj[question.primary.question_id] = cms.asText(question.primary.question_title);
      return obj;
    },
    {},
  );

  const items = Object.keys(teamEffectivenessReport.value.aggregateRatings.changeCounts).map(
    (questionId) => {
      return {
        key: questionIdsToText[questionId],
        value: teamEffectivenessReport.value?.aggregateRatings.changeCounts[questionId],
        colour: CharacterScopeColours[questionId.toLowerCase()] || "black",
      } as CategoryCountDataItem;
    },
  );
  return items;
});

onMounted(() => {
  cms
    .getById(
      CmsDocumentTypes.CmsTeamEffectivenessReview,
      cmsContentMap.teamEffectiveness.questionnaireQuestions,
    )
    .then((d) => {
      teamEffectivenessQuestionnaire.value = d;
      getTeamEffectivenessReport(props.reviewId).then((data) => {
        teamEffectivenessReport.value = data;
      });
    });
});

return (_ctx: any,_cache: any) => {
  return (teamEffectivenessReport.value && teamEffectivenessQuestionnaire.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(HorizontalBarChart, { data: changeData.value }, null, 8, ["data"])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})